/**
 * A component that renders a message user has entered.
 */
import React from "react";
import { connect } from "react-redux";

import styled from "styled-components";

import { Show } from "../../lib/utils";
import { IAMessageContent } from "../InstantAnswers/Messages";
import type { GlobalState } from "../../lib/types";

/**
 * User Message component.
 */
class UserMessage extends React.Component {
  render() {
    const { text, data } = this.props;

    let content = text;

    if (data) {
      // First - check if we are able to render any IA blocks. In case if we screwed up and blocks don't match.
      // But this is unlikely.
      content = IAMessageContent({ values: data?.values, dry: true });
      // If true - render.
      if (content) {
        content = <IAMessageContent values={data?.values} />;
      }
    }

    return (
      <MessageContainer>
        <ResponseWrap>
          <Show when={content}>
            <Message>
              <div className="text">{content}</div>
            </Message>
          </Show>
        </ResponseWrap>
      </MessageContainer>
    );
  }
}

const ResponseWrap = styled.div`
  display: inline-block;
  margin-left: 40px;
  margin-bottom: 16px;
  max-width: calc(100% - 40px);
  text-align: left;
`;

const MessageContainer = styled.div`
  text-align: right;
`;

const Message = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.brandColor};
  color: white;
  border-radius: 24px 24px 3px 24px;
  padding: 10px 16px 11px 21px;
  line-height: 20px;

  .text {
    overflow: hidden;
    -ms-word-wrap: break-word;
    word-wrap: break-word;
    line-height: 20px;
    font-size: ${(props) => props.theme.fontSize || "14px"};
    font-weight: 400;
    letter-spacing: 0.3px;

    p:first-of-type {
      margin-block-start: 0;
    }

    p:last-of-type {
      margin-block-end: 0;
    }
  }
`;

/**
 * Map state to props.
 */
function mapStateToProps(state: GlobalState, ownProps) {
  return {
    text: ownProps.text,
    type: ownProps.type,
    action: ownProps.action,
    answers: ownProps.answers,
    timestamp: ownProps.timestamp,
    data: ownProps.data, // IS message data.
  };
}

export default connect(mapStateToProps)(UserMessage);
